// Date-only strings (e.g. "1990-04-01") are parsed as UTC midnight by the JS
// engine, causing off-by-one-day errors in negative-UTC-offset timezones.
// Appending T00:00:00 forces the engine to parse in the local timezone instead.
function parseBirthdate(birthdate: string): Date {
  return new Date(`${birthdate}T00:00:00`);
}

/** Return true if today falls in the user's birthday month. */
export function isBirthdayMonth(birthdate: string): boolean {
  const today = new Date();
  const bday = parseBirthdate(birthdate);
  return today.getMonth() === bday.getMonth();
}

/** Return number of months until next birthday month (0 if current month). */
export function monthsUntilBirthday(birthdate: string): number {
  const today = new Date();
  const bday = parseBirthdate(birthdate);
  const todayMonth = today.getMonth();
  const bdayMonth = bday.getMonth();
  if (todayMonth === bdayMonth) return 0;
  const diff = (bdayMonth - todayMonth + 12) % 12;
  return diff;
}

/** Return true if today is the exact birthday. */
export function isBirthdayToday(birthdate: string): boolean {
  const today = new Date();
  const bday = parseBirthdate(birthdate);
  return today.getMonth() === bday.getMonth() && today.getDate() === bday.getDate();
}

/** Format a date string to a human-readable month name. */
export function birthdayMonthName(birthdate: string): string {
  const bday = new Date(birthdate);
  return bday.toLocaleString("default", { month: "long" });
}

/** Calculate age from birthdate string as of the current year. */
export function ageThisYear(birthdate: string): number {
  return new Date().getFullYear() - parseBirthdate(birthdate).getFullYear();
}

/** Format an ISO date or date-time string to readable format.
 *
 * Date-only strings (e.g. "2026-09-20") are parsed as UTC midnight by the
 * JS engine, same off-by-one-day issue as parseBirthdate above -- append
 * T00:00:00 so they parse in the local timezone instead. Date-time strings
 * (e.g. badge earned_at, "2026-09-20T00:00:00") already have a time
 * component and parse as local time as-is. */
export function formatDate(iso: string): string {
  const withTime = iso.includes("T") ? iso : `${iso}T00:00:00`;
  return new Date(withTime).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}
